import { FC } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';

import { IPrivateLayoutProps } from './types';
import { StyledMainContent, StyledMainLayout } from './styled';
import { Header, Sidebar } from './components';

const ROUTES_TO_HIDE_ALL = ['/pdf-viewer'];

const PrivateLayout: FC<IPrivateLayoutProps> = ({ sidebarMenu, children }) => {
  const { pathname } = useLocation();

  if (ROUTES_TO_HIDE_ALL.find(item => pathname.includes(item))) {
    return <>{children}</>;
  }

  return (
    <StyledMainLayout>
      <Header />
      <Layout>
        <Sidebar sidebarMenu={sidebarMenu} />
        <StyledMainContent>{children}</StyledMainContent>
      </Layout>
    </StyledMainLayout>
  );
};

export default PrivateLayout;
